import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import MedicalHistory from './Component/MedicalHistory';


const mapStateToProps = (state, ownProps) => ({
    
});


const mapDispatchToProps = (dispatch) => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(MedicalHistory)